import { Component, OnInit, ViewChild, AfterViewInit, ElementRef } from '@angular/core';
import { DocService, eDocType, ISearchNode, IClassNode } from "../services/doc.service";


interface ISearchResults {
	classResults: ISearchNode[];
	propertyResults: ISearchNode[];
	methodResults: ISearchNode[];
	summaryResults: ISearchNode[];
}

@Component({
	selector: 'search-component',
	templateUrl: './search.component.html',
	styleUrls: ['./search.component.scss']
})

export class SearchComponent implements OnInit {
	@ViewChild('filter', { static: false }) _filterInput: ElementRef;
	private _module: any;
	private _searchResults: ISearchResults = undefined;
	private _searchTimeout: any = undefined;
	private _cancelSearch: boolean = true;
	private _maxSearchResults: number = 100;

	constructor(private _docService: DocService) {
	}

	ngOnInit() {
		this._module = 'ixnetwork_restpy.testplatform.testplatform.TestPlatform';
	}

	ngAfterViewInit() {
	}

	public getDocNodeIcon(docType: eDocType): string {
		return this._docService.getDocNodeIcon(docType);
	}

	async cancelSearch(value: string) {
		this._cancelSearch = true;
		if (this._searchTimeout) {
			clearTimeout(this._searchTimeout);
		}
		if (value === undefined || value.length === 0) {
			this._searchResults = undefined;
		}
	}

	onSearchResult(searchResult: ISearchNode) {
		this._filterInput.nativeElement.value = "";
		this.cancelSearch(undefined);
		this._docService.SetSearchResult(searchResult);
	}

	filterHierarchy(value: string) {
		this.cancelSearch(value);
		if (value && value.length > 0) {
			this._searchTimeout = setTimeout(() => {
				this._cancelSearch = false;
				this._searchResults = {
					classResults: [],
					propertyResults: [],
					methodResults: [],
					summaryResults: []
				};
				let visited: any[] = [];
				this.search(value, this._module, visited);
			});
		}
	}

	get isSearchDone(): boolean {
		if (this._cancelSearch) {
			return true;
		}
		if (this._searchResults === undefined) {
			return true;
		}
		let results = this._searchResults.classResults.length + this._searchResults.methodResults.length + this._searchResults.propertyResults.length; if (results > this._maxSearchResults) {
			return true;
		}
	}

	getMatches(pattern: string, valueToSearch: string): number {
		let matches: number = 0;
		valueToSearch = valueToSearch.toLowerCase();
		for(let patternValue of pattern.toLowerCase().split(' ')) {
			if (valueToSearch.indexOf(patternValue) > -1) {
				matches++;
			} else {
				return 0;
			}
		}
		return matches;
	}

	addSearchResult(container: any[], matches: number, name: string, key:string, docType: eDocType, summary: string) {
		if (matches > 0) {
			let finalKey: string = 'ixnetwork_restpy';
			for (let piece of key.split('.')) {
				if (finalKey.endsWith(piece.toLowerCase()) === false) {
					finalKey += `.${piece.toLowerCase()}`;
				}
			}
			container.push(
				{
					matches: matches,
					name: name,
					key: finalKey,
					docType: docType,
					summary: summary ? summary.replace(/^[\s\n]+|[\s\n]+$/, '') : ''
				}
			)
		}
	}

	matchClass(searchValue: string, key: string, docNode: IClassNode) {
		if (!this.isSearchDone && docNode) {
			this.addSearchResult(this._searchResults.classResults, 
				this.getMatches(searchValue, key), 
				docNode.Class, 
				key, 
				eDocType.class, 
				docNode.Summary);
		}
	}

	matchProperty(searchValue: string, key: string, docNode: IClassNode, visited: string[]) {
		if (docNode && docNode.Properties) {
			for (let property of docNode.Properties) {
				if (this.isSearchDone) {
					return;
				}
				if (property.Link) {
					this.search(searchValue, property.Link, visited);
				} else {
					this.addSearchResult(this._searchResults.propertyResults, 
						this.getMatches(searchValue, `${key}.${property.Signature}`), 
						`${docNode.Class}.${property.Signature}`, 
						`${key}.${property.Signature}`, 
						eDocType.property, 
						property.Summary);		
				}
			}
		}
	}

	matchMethod(searchValue: string, key: string, docNode: IClassNode) {
		if (docNode && docNode.Methods) {
			for (let method of docNode.Methods) {
				if (this.isSearchDone) {
					return;
				}
				this.addSearchResult(this._searchResults.methodResults, 
					this.getMatches(searchValue, `${key}.${method.Signature}`), 
					`${docNode.Class}.${method.Signature}`, 
					`${key}.${method.Signature.substring(0, method.Signature.indexOf('('))}`, 
					eDocType.method, 
					method.Summary);		
			}
		}
	}

	search(value: string, key: string, visited: string[]) {
		if (this.isSearchDone || visited.indexOf(key) !== -1) {
			return;
		} else {
			visited.push(key);
		}
		let docNode = this._docService.getDocNode(key);
		this.matchClass(value, key, docNode);
		this.matchProperty(value, key, docNode, visited);
		this.matchMethod(value, key, docNode);
	}

	get searchResults(): ISearchResults {
		return this._searchResults;
	}
}
